import React from 'react';
import { Select, MenuItem, OutlinedInput } from '@material-ui/core';
import classnames from 'classnames';
import classes from './SimpleSelect.module.scss';
import ChevronDown from '../icons/ChevronDown';

type SimpleSelectProps = {
    placeholder?: string; 
    formId?: string;
    className?: string;
    values: MenuOption[];
    onChange?: (value:MenuOption) => void;
    value?: MenuOption;
    autoFocusInput?: boolean;
}

const SimpleSelect: React.FC<SimpleSelectProps> = ({
    placeholder,
    autoFocusInput,
    className:propsClassName,
    formId,
    values=[],
    onChange,
    value,
}) => {

    function renderSelectedValue (val) {
        if (!val) {
            return placeholder ?? '';
        }
        const option = values.find((v: MenuOption) => v.val === val);
        return <>{option?.label ?? ''}</>;
    }
    function onSelectChange (evt) {
        const value = evt.target.value;
        const selectedOpt = values.find(v => v.val === value);
        if (selectedOpt && onChange) {
            onChange(selectedOpt);
        }
    }
    return (
        <Select
            id="suralinkSelect"
            labelId={ formId ?? ''}
            value={value ?? ''}
            renderValue={renderSelectedValue}
            className={classnames(classes.suralinkSelect, propsClassName)}
            classes={{
                select: classes.selectLabel,
            }}
            onChange={onSelectChange}
            IconComponent={ChevronDown}
            input={
                <OutlinedInput
                    autoFocus={autoFocusInput}
                    classes={{
                        root: classes.outlinedInputRoot,
                        focused: classes.outlinedInputFocused,
                        notchedOutline: classes.notchedOutline
                    }}
                />
            }
            MenuProps={{
                id: 'suralinkSelectDropdown',
                autoFocus: false,
                getContentAnchorEl: null,
                classes: {
                    list: classes.dropdownList,
                },
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
                PopoverClasses: {
                    root: classes.suralinkSelectDropdown,
                    paper: classes.selectDropdownPaper
                }
            }}
            displayEmpty
        >
            { values.map((v: MenuOption) => (
                    <MenuItem
                        value={v.val}
                        key={v.val}
                        classes={{
                            root: classes.menuItem,
                            selected: classes.selectedItem,
                        }}
                        focusVisibleClassName={ classes.focusVisible}
                    >
                        <div className={classes.menuItemLabel}>
                            {v.label}
                        </div>
                    </MenuItem>
                ))
            }
        </Select>
    );
}

export default SimpleSelect;
